<template>
  <div>
    <PageHeader
        title="Vámhatározat"
        :special-back-link="true"
        :enable-back-link="true"
        @goBack="goBack"
    />
    <div v-if="details && details.uploadedFiles && details.uploadedFiles.length > 0">
      <b-tabs v-model="activeTab" style="width: 100% !important;" lazy>
        <b-tab
            v-for="(file, index) in details.uploadedFiles"
            :key="file.fileStoreId"
            :title="file.fileName"
        >
          <customs-detail 
              :details="details" 
              :selected-file="details.uploadedFiles[index]"
          />
        </b-tab>
      </b-tabs>
    </div>
    <div v-else-if="loading" class="text-center p-5">
      <b-spinner label="Betöltés..."></b-spinner>
      <p class="mt-2">Adatok betöltése...</p>
    </div>
    <div v-else class="text-center p-5">
      <p>Nincs csatolt fájl.</p>
    </div>
  </div>
</template>

<script>
import Api from "api-client";
import { mapGetters } from "vuex";

import PageHeader from "@/components/PageHeader.vue";
import CustomsDetail from "@/views/app/costs/CustomsDetail.vue";

export default {
  name: "CustomsView",
  components: { CustomsDetail, PageHeader },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      details: null,
      activeTab: 0,
      loading: true,
    }
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    getCustomsDetails() {
      this.loading = true;
      Api.getCustomsDetails(this.id, this.getActiveCompany.id)
        .then(response => {
          this.details = response.data;
        })
        .catch(error => {
          console.error("Error fetching customs details:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getCustomsDetails();
  },
}
</script>

<style scoped>
::v-deep .nav-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

::v-deep .nav-tabs::-webkit-scrollbar {
  height: 4px;
}

::v-deep .nav-tabs::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::v-deep .nav-tabs::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}

::v-deep .nav-tabs .nav-item {
  flex-shrink: 0;
}

::v-deep .nav-tabs .nav-link {
  white-space: nowrap;
}
</style>
